







import { Component, Vue } from 'vue-property-decorator';
import Auth from '@/services/Auth';
import { captureException as SentryCaptureException } from '@sentry/browser';

// Components
import Loading from '@/components/Global/Loading.vue';

@Component({
	name: 'VerifyCode',
	components: {
		Loading,
	},
})
export default class VerifyCode extends Vue {
	private async created() {
	
		console.log(`VerifyCode()->created() is calling....`);

		try {

			console.log(`Ivan: ${JSON.stringify(this.$route.query, null, 2)}`);

			// Retrieve the transferred session from the service.
			const session = await Auth.acquireTransferredSession(this.$route.query.code);

			// Navigate to just the path portion of the session's `redirectUri` using `router.replace()` instead of
			// `window.location.assign()` with the full URL for two reasons: 1) To avoid doing a complete reload of
			// the SPA runtime, and 2) to prevent the current route from being added to the browser's history.
			const parsedRedirectUrl = new URL(session.redirectUri);
			this.$router.replace(parsedRedirectUrl.pathname);
		} catch (error) {
			SentryCaptureException(error);

			this.$router.push({
				name: 'login',
				params: {
					error: true,
				},
			});
		}
	}
}
